module.exports = __webpack_public_path__ + "catalog/items/recycling-bins/recycling-bins.png";